import { SecondScreenOperation } from "@/Common/Models/SecondScreen/Enum/SecondScreenOperation";
import { SecondScreenNoteData } from "@/Common/Models/SecondScreenNoteData";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { SecondScreenNoteService } from "@/Common/Services/SecondScreenNoteService";

export class SecondScreenHelper {
    public static openWindow(noteData: Partial<SecondScreenNoteData>): void {
        const payload = this.getSecondScreenNoteDataModel(noteData);
        SecondScreenNoteService.getInstance().openWindow(payload, true);
    }

    public static executeOperation(operation: SecondScreenOperation, payload: any): void {
        switch (operation) {
            case SecondScreenOperation.FilterEncounterUnapprovedNotes:
                sessionStore.dispatch(LocalPatientOperations.MedicalSummary.EncounterUnapprovedNotesFilterTermChanged, payload);
                break;

            case SecondScreenOperation.FilterEncounterMyNotes:
                sessionStore.dispatch(LocalPatientOperations.MedicalSummary.EncounterMyNotesFilterTermChanged, payload);
                break;

            case SecondScreenOperation.FilterEncounterClinicVisitNotes:
                sessionStore.dispatch(LocalPatientOperations.MedicalSummary.EncounterClinicVisitNotesFilterTermChanged, payload);
                break;

            case SecondScreenOperation.ConfigureNotes:
                const { dateFrom, dateTo } = payload;

                sessionStore.dispatch(LocalPatientOperations.MedicalSummary.EncounterDateFromChanged, { value: dateFrom });
                sessionStore.dispatch(LocalPatientOperations.MedicalSummary.EncounterDateToChanged, { value: dateTo });

                patientStore.EmitChangeToListeners();
                break;
        }
    }

    private static getSecondScreenNoteDataModel(payload: Partial<SecondScreenNoteData>): SecondScreenNoteData {
        const medicalSummaryModel = patientStore.PatientMedicalSummaryModels[payload.patientId];
        const encounterFilterMyNotes = medicalSummaryModel?.get("EncounterFilterMyNotes");
        const encounterFilterUnapprovedNotes = medicalSummaryModel?.get("IsDisplayingOnlyUnsigned");
        const encounterFilterClinicVisitNotes = medicalSummaryModel?.get("IsDisplayOnlyClinicVisitNotes");

        return new SecondScreenNoteData({
            ...payload,
            encounterFilterMyNotes,
            encounterFilterUnapprovedNotes,
            encounterFilterClinicVisitNotes
        });
    }
}
